import { RichTextEditorControlsWrapper } from 'components/editor/RichTextEditor.styles';
import styled from 'styled-components';

export const RichTextEditorFieldStyled = styled.div`
  .editable-area[role='textbox'] {
    height: 114px;
    margin-bottom: 0;
    min-height: 114px;
    overflow: auto;
    padding: 6px 12px;
  }

  ${RichTextEditorControlsWrapper} {
    display: none;
  }
`;
